import React from "react";
import { Calendar, MapPin } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

interface EventHeaderProps {
  title: string;
  date: string;
  location: string;
  image: string;
  virtualEvent: string;
}

const EventHeader: React.FC<EventHeaderProps> = ({
  title,
  date,
  location,
  image,
  virtualEvent,
}) => {
  const isMobile = useIsMobile();

  return (
    <div
      className={`bg-cover bg-center ${isMobile ? "h-48" : "h-64"} relative`}
      style={{ backgroundImage: `url(${image})` }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-60">
        <div className="max-w-5xl mx-auto h-full px-4 flex flex-col justify-end pb-6 md:pb-8 text-white">
          <h1
            className={`${
              isMobile ? "text-2xl" : "text-3xl"
            } font-bold leading-tight`}
          >
            {title}
          </h1>
          <div className="flex flex-wrap items-center mt-2 text-sm">
            <div className="flex items-center mr-4 mb-1">
              <Calendar className="h-4 w-4 mr-1 flex-shrink-0" />
              <span>
                {new Date(date).toLocaleDateString("en-US", {
                  weekday: isMobile ? "short" : "long",
                  year: "numeric",
                  month: isMobile ? "short" : "long",
                  day: "numeric",
                })}
              </span>
            </div>
            {virtualEvent === "No" && (
              <div className="flex items-center">
                <MapPin className="h-4 w-4 mr-1 flex-shrink-0" />
                <span>{location}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventHeader;
